<div class="table-component">
  <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 table">

    <!-- Datum -->
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="date">Datum</th>
      <td mat-cell *matCellDef="let element">
        {{ element.date | date:'dd.MM.yyyy, HH:mm' }}
      </td>
    </ng-container>

    <!-- Zählerstand -->
    <ng-container matColumnDef="meter_amount">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="meter_amount">Zählerstand</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.meter_amount !== null && element.meter_amount !== undefined; else dash">
          {{ element.meter_amount | number:'1.0-1' }} kWh
        </ng-container>
      </td>
    </ng-container>

    <!-- Außentemperatur (°C) -->
    <ng-container matColumnDef="outside_temperature">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="outside_temperature">Außentemperatur Mittel</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.outside_temperature !== null && element.outside_temperature !== undefined; else dash">
          {{ element.outside_temperature | number:'1.0-1' }} °C
        </ng-container>
      </td>
    </ng-container>

    <!-- Verbrauch (kWh) – berechnet wie im Chart -->
    <ng-container matColumnDef="consumption">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="consumption">Verbrauch</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element._computedConsumption !== null && element._computedConsumption !== undefined; else dash">
          {{ element._computedConsumption | number:'1.0-1' }} kWh
        </ng-container>
      </td>
    </ng-container>

    <!-- Vorjahr (kWh) – 0,0 wenn Verbrauch vorhanden, sonst "–" -->
    <ng-container matColumnDef="prev_year_consumption">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="prev_year_consumption">Vorjahr</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element._computedPrevYear !== null && element._computedPrevYear !== undefined; else dash">
          {{ element._computedPrevYear | number:'1.0-1' }} kWh
        </ng-container>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    <ng-template #dash>–</ng-template>
  </table>
</div>
